var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8941be41afebbd7f5a82e273872415ad95f3de30"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["thermal-web@thermal-wa"]={id:"8941be41afebbd7f5a82e273872415ad95f3de30"};
      